import { InvoiceSummary } from "./invoice"

export const isInvoiceExportedToQuickBooks = (invoice: InvoiceSummary): boolean => {
  return invoice.qboInvoiceId.length > 0
}

export const shouldShowTrackingColumn = (
  isTenantConnectedToQuickBooks: boolean,
  invoices: InvoiceSummary[]
): boolean => {
  if (!isTenantConnectedToQuickBooks) {
    return false
  }
  return invoices.some((invoice) => invoice.invoicingSystem === 'synkedUp')
}

export const shouldShowSyncInvoiceButton = (
  isTenantConnectedToQuickBooks: boolean,
  invoice: InvoiceSummary
): boolean => {
  if (!isTenantConnectedToQuickBooks) {
    return false
  }
  if (invoice.invoicingSystem !== 'synkedUp') {
    return false
  }
  const isExported = isInvoiceExportedToQuickBooks(invoice)
  const isSynced = isExported && !invoice.hasUnexportedPayment
  return !isSynced
}
